/* ==========================================================================
   assets/upgrade-ar-names.js -- phone and brand names in Arabic script, in the
   browser. AR BRAND NAMES, 11 Oct 2026 (2026-10-11_ar-brand-names/CHANGES.md).
   Omar: "i want all apple and samsung written in arabic like the home page as
   well" (the /ar home hero, which already writes both names in Arabic).

   Loaded ONLY on a page that is not in the shop's primary language, by
   snippets/upgrade-ar-names.liquid (mode 'script') from layout/theme.liquid
   <head>, right after window.UpgradeArNamesTable. THE SPELLING TABLE lives in
   that snippet and nowhere else; this file has no spelling of its own. An
   English page never loads this file, so nothing on it changes.

   The rules are the snippet's, word for word (tests/ar-brand-names-11oct.
   test.js runs both on the same lines): brand words (Apple, Samsung) and
   phone families (iPhone, Galaxy) change wherever they stand; model words
   (Pro, Max, Plus, Ultra) only inside a phone's name (after iPhone or Galaxy
   and the model number); model numbers, letters and storage stay as written;
   a lone «و» before a name joins it; a brand word before a KEEP AFTER word
   (Apple Pay), a name after a KEEP BEFORE word (Find My iPhone) and an English
   line (Latin words other than names, model codes and the table's NOT ENGLISH
   words such as the shop's own name, and no Arabic letter) stay as written.

   WHERE IT APPLIES. One watcher on the whole page (a MutationObserver on
   <html>, started from <head>), so every display point is covered whoever
   writes it: the server, or a script later -- the shop's cards, Brand and
   Model filters and chips; the product page (H1, crumb, brand line, specs,
   related phones, sticky bar, photo alts); the home rail; the trade-in and
   sell tools (model pickers, summaries); the trade-in bar; the cart; the
   search results; the browser tab (<title>). A text a script writes is
   changed before the page is painted (observer callbacks run before the next
   paint). It changes ONLY text nodes and four attributes people read or hear:
   alt, title, aria-label, placeholder.

   NEVER TOUCHED: <script>, <style>, <noscript>, <textarea>, <code>, <pre>,
   form values, data-* attributes, href/src, ids and classes; anything in
   <head> but <title>; text marked as another language (the nearest lang=""
   is not the page's: the trade-in notes in the cart are lang="en" on
   purpose, decision D7); the policy pages (.shopify-policy__container, under
   legal review); anything inside [data-ug-ar-names-skip]; the predictive
   search's "search for «...»" line ([data-predictive-search-search-for-text]),
   which repeats the customer's own typed words.

   REVIEW FIX, 11 Oct 2026 (should-fix; 2026-10-11_ar-brand-names/CHANGES.md):
   Dawn's assets/predictive-search.js updateSearchForTerm() reads that line
   back and runs text.match(new RegExp(the typed term, 'g')).length on it.
   Once a typed "iPhone" there read in Arabic, match() returned null and threw
   inside onChange(), before the new term was kept and before the
   suggestions were fetched, so /ar/search suggestions froze after a
   capitalised brand or family word. The line is now left as typed.

   Two scripts check a button's own text to put the keyboard focus back after
   they redraw (assets/upgrade-tradein.js and upgrade-sell.js restoreFocus).
   They read the Arabic text before the redraw and the Latin text after it,
   so on this page they no longer match for a model button; FOCUS below puts
   the focus back the same way, on the Latin text, before the new text is
   changed. Neither script is edited.

   window.UpgradeArNames (only on such a page):
     text(s)        s with the names in the table's Arabic (rules above)
     apply(root)    every text node and the four attributes under root
     searchText(s)  text(s), normalised for search (hamza forms, ta marbuta,
                    alef maqsura, no diacritics or tatweel)
     searchNorm(s)  what a customer typed, normalised the same way, with the
                    table's SEARCH spellings mapped to the table's own
     TABLE          the parsed table (read only)
   assets/upgrade-catalogue.js uses searchText/searchNorm, so the Arabic for "iPhone 15" finds
   the iPhone 15 and "iPhone 15" still does.

   NEVER THROWS: any error leaves the page as the other scripts wrote it.
   ========================================================================== */
(function (w, d) {
  'use strict';
  try {
    if (w.UpgradeArNames && w.UpgradeArNames.__ready) { return; }
  } catch (e0) { return; }
  var RAW = null;
  try { RAW = w.UpgradeArNamesTable || null; } catch (e1) { RAW = null; }
  if (!RAW || typeof RAW.brands !== 'string') { return; }

  function pairs(s) {
    var out = [];
    String(s || '').split('|').forEach(function (p) {
      var i = p.indexOf('=');
      if (i > 0) { out.push([p.slice(0, i), p.slice(i + 1)]); }
    });
    return out;
  }
  function list(s) { return String(s || '').split('|').filter(function (x) { return x !== ''; }); }

  var BRANDS = pairs(RAW.brands);
  var FAMILIES = pairs(RAW.families);
  var WORDS = pairs(RAW.words);
  var KEEP_AFTER = list(RAW.keepAfter);
  var KEEP_BEFORE = list(RAW.keepBefore);
  var SEARCH = pairs(RAW.search);
  var NOT_ENGLISH = list(RAW.notEnglish);
  var KEYS = BRANDS.concat(FAMILIES).map(function (p) { return p[0]; });
  // the marks a word may carry: brackets, quotes, punctuation, and the invisible direction marks the scripts put
  // around a name on a right-to-left page (U+2066-2069 isolates, U+200E/200F/061C marks)
  var PRE = '(«"[\u2066\u2067\u2068\u200e\u200f\u061c';
  var POST = '،,.:;)»"!?]؟…\u2069\u200e\u200f\u061c';
  var ARABIC = /[ء-يٱ-ۓ]/;
  var DIGIT = /[0-9]/;

  function look(table, word) {
    for (var i = 0; i < table.length; i++) { if (table[i][0] === word) { return table[i][1]; } }
    return null;
  }
  function bare(t) {
    return String(t == null ? '' : t).replace(/[،,.:)»\u2066-\u2069\u200e\u200f\u061c]/g, '');
  }

  // The snippet's loop, token by token. Whitespace between words is kept as it was.
  function text(input) {
    try {
      var s = String(input == null ? '' : input);
      if (s === '') { return s; }
      var hit = false;
      for (var h = 0; h < KEYS.length; h++) { if (s.indexOf(KEYS[h]) !== -1) { hit = true; break; } }
      if (!hit) { return s; }
      var parts = s.split(/(\s+)/);
      var toks = [];
      for (var p = 0; p < parts.length; p += 2) { toks.push(parts[p]); }
      var res = '';
      var inName = false;
      var latin = false;
      var prev = '';
      var prevRaw = '';
      var started = false;
      for (var j = 0; j < toks.length; j++) {
        var t = toks[j];
        var sep = j > 0 ? parts[2 * j - 1] : '';
        if (t === '') { res += sep; continue; }
        var pre = '';
        var post = '';
        var core = t;
        for (var q = 0; q < 2; q++) {   // up to two marks before the word ("(\u2068iPhone")
          if (core.length > 1 && PRE.indexOf(core.charAt(0)) !== -1) { pre = pre + core.charAt(0); core = core.slice(1); }
        }
        for (var r = 0; r < 3; r++) {   // up to three marks after the word ("Galaxy...")
          if (core.length > 1 && POST.indexOf(core.charAt(core.length - 1)) !== -1) { post = core.charAt(core.length - 1) + post; core = core.slice(0, -1); }
        }
        var up = core.toUpperCase();
        var dn = core.toLowerCase();
        var code = DIGIT.test(core) || (core.length < 3 && up === core && dn !== core);
        var fresh = '';
        var name = false;
        var fam = false;
        var b = look(BRANDS, core);
        if (b !== null) { fresh = b; name = true; }
        var f = look(FAMILIES, core);
        if (f !== null) { fresh = f; name = true; fam = true; }
        if (name) {
          var next = j + 1 < toks.length ? bare(toks[j + 1]) : '';
          if (KEEP_AFTER.indexOf(next) !== -1 || KEEP_BEFORE.indexOf(prev) !== -1) { fresh = ''; name = false; fam = false; }
        }
        if (fresh === '' && inName) {
          var m = look(WORDS, core);
          if (m !== null) { fresh = m; }
          else if (!code) { inName = false; }
        }
        if (fam) { inName = true; }
        if (post !== '') { inName = false; }
        if (fresh === '' && !code && up !== dn && NOT_ENGLISH.indexOf(core) === -1) { latin = true; }
        var piece = fresh === '' ? t : pre + fresh + post;
        if (!started) { res += sep + piece; started = true; }
        else if (prevRaw === 'و' && name) { res += piece; }
        else { res += sep + piece; }
        prev = core;
        prevRaw = t;
      }
      if (!ARABIC.test(s) && latin) { return s; }
      return res;
    } catch (e) { return input; }
  }

  /* ---- search ---------------------------------------------------------- */
  function norm(s) {
    return String(s == null ? '' : s)
      .replace(/[ً-ْٰـ]/g, '')
      .replace(/[أإآٱ]/g, 'ا')
      .replace(/ى/g, 'ي')
      .replace(/ة/g, 'ه')
      .replace(/ؤ/g, 'و')
      .replace(/ئ/g, 'ي');
  }
  var SEARCH_N = SEARCH.map(function (p) { return [norm(p[0]), norm(p[1])]; });
  function searchText(s) {
    try { return norm(text(s)); } catch (e) { return ''; }
  }
  function searchNorm(s) {
    try {
      var out = norm(s);
      SEARCH_N.forEach(function (p) {
        out = out.split(/(\s+)/).map(function (word) { return word === p[0] ? p[1] : word; }).join('');
      });
      return out;
    } catch (e) { return s; }
  }

  /* ---- the page --------------------------------------------------------- */
  var ATTRS = ['alt', 'title', 'aria-label', 'placeholder'];
  var SKIP_TAGS = { SCRIPT: 1, STYLE: 1, NOSCRIPT: 1, TEXTAREA: 1, CODE: 1, PRE: 1, TEMPLATE: 1, IFRAME: 1 };
  // [data-predictive-search-search-for-text]: Dawn reads it back as a RegExp of the typed term (REVIEW FIX, header)
  var SKIP_SEL = '[data-ug-ar-names-skip], .shopify-policy__container, [data-predictive-search-search-for-text]';
  var PAGE_LANG = '';
  try { PAGE_LANG = String(d.documentElement.getAttribute('lang') || '').toLowerCase().split('-')[0]; } catch (e2) { PAGE_LANG = ''; }
  // node -> { orig: the text a script wrote, out: what this file made of it }
  var SEEN = (typeof WeakMap === 'function') ? new WeakMap() : null;

  function allowed(el) {
    if (!el || el.nodeType !== 1) { return false; }
    if (SKIP_TAGS[el.nodeName]) { return false; }
    if (el.closest) {
      if (el.closest(SKIP_SEL)) { return false; }
      if (el.nodeName !== 'TITLE' && el.closest('head')) { return false; }
      if (el.closest('script, style, noscript, textarea, code, pre')) { return false; }
      var l = el.closest('[lang]');
      if (l && l !== d.documentElement) {
        var lang = String(l.getAttribute('lang') || '').toLowerCase().split('-')[0];
        if (PAGE_LANG && lang && lang !== PAGE_LANG) { return false; }
      }
    }
    return true;
  }

  function fixText(node) {
    var parent = node.parentNode;
    if (!parent || !allowed(parent)) { return; }
    fixTextHere(node);
  }

  // a text node already known to be in an allowed place
  function fixTextHere(node) {
    var v = node.nodeValue;
    var from = v;
    var was = SEEN ? SEEN.get(node) : null;
    if (was) {
      if (v === was.out) { return; }
      // the parser added to a text this file had already changed: change the whole again
      if (was.out && v.indexOf(was.out) === 0) { from = was.orig + v.slice(was.out.length); }
    }
    var n = text(from);
    if (n !== v) {
      if (SEEN) { SEEN.set(node, { orig: from, out: n }); }
      node.nodeValue = n;
    }
  }

  function fixAttr(el, a) {
    if (!el.hasAttribute || !el.hasAttribute(a)) { return; }
    var v = el.getAttribute(a);
    var n = text(v);
    if (n !== v) { el.setAttribute(a, n); }
  }

  function fixEl(el) {
    for (var i = 0; i < ATTRS.length; i++) { fixAttr(el, ATTRS[i]); }
  }

  function apply(root) {
    try {
      if (!root) { return; }
      if (root.nodeType === 3) { fixText(root); return; }
      if (root.nodeType !== 1 || !allowed(root)) { return; }
      fixEl(root);
      // below an allowed root, the filter alone decides: a refused element's whole subtree is left out
      var walker = d.createTreeWalker(root, 5 /* SHOW_ELEMENT | SHOW_TEXT */, {
        acceptNode: function (n) {
          if (n.nodeType === 1) {
            if (SKIP_TAGS[n.nodeName]) { return 2; /* REJECT */ }
            if (n.parentNode && n.parentNode.nodeName === 'HEAD' && n.nodeName !== 'TITLE') { return 2; }
            if (n.matches && n.matches(SKIP_SEL)) { return 2; }
            if (n.hasAttribute && n.hasAttribute('lang') && n !== d.documentElement) {
              var lang = String(n.getAttribute('lang') || '').toLowerCase().split('-')[0];
              if (PAGE_LANG && lang && lang !== PAGE_LANG) { return 2; }
            }
          } else if (n.parentNode && n.parentNode.nodeName === 'HEAD') {
            return 2;
          }
          return 1; /* ACCEPT */
        }
      });
      var batch = [];
      var n = walker.nextNode();
      while (n) { batch.push(n); n = walker.nextNode(); }
      for (var i = 0; i < batch.length; i++) {
        if (batch[i].nodeType === 3) { fixTextHere(batch[i]); }
        else { fixEl(batch[i]); }
      }
    } catch (e) { /* the page stays as written */ }
  }

  /* ---- FOCUS (see the header) -------------------------------------------- */
  var lastFocus = null;
  function plainOf(el) {
    // the element's text as the script wrote it, before this file changed it
    var out = '';
    var walker = d.createTreeWalker(el, 4 /* SHOW_TEXT */, null);
    var n = walker.nextNode();
    while (n) {
      var was = SEEN ? SEEN.get(n) : null;
      out += (was && n.nodeValue === was.out) ? was.orig : n.nodeValue;
      n = walker.nextNode();
    }
    return out;
  }
  function onFocus(e) {
    try {
      var el = e.target;
      if (!el || el.nodeName !== 'BUTTON') { lastFocus = null; return; }
      // the first class and the text, as the two tools' own restoreFocus() key a button
      lastFocus = { el: el, cls: String(el.className || '').split(' ')[0], text: plainOf(el) };
    } catch (err) { lastFocus = null; }
  }
  function refocus(records) {
    try {
      if (!lastFocus || lastFocus.el.isConnected !== false) { return; }
      var a = d.activeElement;
      if (a && a !== d.body && a !== d.documentElement) { return; }
      var removedHere = false;
      for (var r = 0; r < records.length && !removedHere; r++) {
        var rem = records[r].removedNodes || [];
        for (var k = 0; k < rem.length; k++) {
          if (rem[k] === lastFocus.el || (rem[k].contains && rem[k].contains(lastFocus.el))) { removedHere = true; break; }
        }
      }
      if (!removedHere) { return; }
      var first = lastFocus.cls;
      if (!first) { return; }
      var list = d.getElementsByClassName(first);
      for (var i = 0; i < list.length; i++) {
        var b = list[i];
        if (b.nodeName === 'BUTTON' && String(b.className || '').split(' ')[0] === first && b.textContent === lastFocus.text) {
          try { b.focus({ preventScroll: true }); } catch (e1) { b.focus(); }
          lastFocus = { el: b, cls: lastFocus.cls, text: lastFocus.text };
          return;
        }
      }
    } catch (e) { /* no focus to put back */ }
  }

  /* ---- the watcher -------------------------------------------------------- */
  function onMutations(records) {
    refocus(records);
    for (var i = 0; i < records.length; i++) {
      var r = records[i];
      if (r.type === 'childList') {
        for (var k = 0; k < r.addedNodes.length; k++) { apply(r.addedNodes[k]); }
      } else if (r.type === 'characterData') {
        apply(r.target);
      } else if (r.type === 'attributes' && r.target && allowed(r.target)) {
        fixAttr(r.target, r.attributeName);
      }
    }
  }

  w.UpgradeArNames = {
    __ready: true,
    text: text,
    apply: apply,
    searchText: searchText,
    searchNorm: searchNorm,
    TABLE: { brands: BRANDS, families: FAMILIES, words: WORDS, keepAfter: KEEP_AFTER, keepBefore: KEEP_BEFORE, notEnglish: NOT_ENGLISH, search: SEARCH }
  };

  try {
    if (typeof MutationObserver === 'function' && d.documentElement) {
      new MutationObserver(onMutations).observe(d.documentElement, {
        childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ATTRS
      });
    }
    d.addEventListener('focusin', onFocus, true);
    apply(d.documentElement);
    var once = function () { apply(d.documentElement); };
    if (d.readyState === 'loading') { d.addEventListener('DOMContentLoaded', once); } else { once(); }
  } catch (e3) { /* the page stays as written */ }
})(window, document);
